<template>
  <b-modal :model-value="show" title="不法投棄情報" @hide="resetModal" @update:model-value="$emit('update:show', $event)" size="xl" centered>
    <div>
      <p>登録日: {{ wasteData.registrationDate }}</p>
      <p>廃棄物の種類: {{ wasteData.wasteType }}</p>
      <p>報告者: {{ wasteData.reporter }}</p>
      <p>廃棄物: {{ wasteData.discardedItem }}</p>
      <p>個数: {{ wasteData.quantity }}</p>
      <p>備考: {{ wasteData.remarks }}</p>
      <img v-if="wasteData.s3Url" :src="wasteData.s3Url" alt="Waste Image" class="waste-image" />
    </div>
    <template #modal-footer>
      <b-button variant="secondary" @click="closeModal">閉じる</b-button>
    </template>
  </b-modal>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      required: true
    },
    wasteData: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ['update:show', 'reset-data'],
  methods: {
    closeModal() {
      this.$emit('update:show', false);
    },
    resetModal() {
      this.$emit('update:show', false);
      this.$emit('reset-data'); // モーダルを閉じたときにデータをリセット
    }
  }
};
</script>

<style scoped>
.modal-dialog {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  /* 垂直方向の中央配置 */
}
.waste-image {
  max-width: 100%; /* 画像の最大幅をモーダルに合わせる */
  height: auto; /* アスペクト比を維持 */
  display: block;
  margin: 0 auto; /* 中央に配置 */
  border: 2px solid #ccc; /* 枠線を追加 */
  padding: 5px; /* 枠線と画像の間に余白を追加 */
}
</style>
